import { useMemo } from 'react'
import { createStore } from 'jotai'
import { creditTokenApiKeyAtom, creditTokenPublicKeyAtom } from '@!/atoms/paymentAtom'

/**
 * ExternalPayment用の設定フック
 * JotaiストアにGMOクレジットトークンAPI設定を登録
 * @param {Object} settings - 設定値
 * @param {string} settings.creditTokenApiKey - GMO クレジットトークンAPI用のAPIキー
 * @param {string} settings.creditTokenPublicKey - GMO クレジットトークンAPI用の公開鍵
 * @returns {Object} Jotaiストア
 */
export const useExternalPaymentSettings = ({ creditTokenApiKey, creditTokenPublicKey }) => {
  // useMemoでストアをメモ化し、再レンダリング時の再作成を防ぐ
  // creditTokenApiKey, creditTokenPublicKeyは初期化パラメータであり、動的に変更されない
  const store = useMemo(() => {
    const newStore = createStore()
    newStore.set(creditTokenApiKeyAtom, creditTokenApiKey)
    newStore.set(creditTokenPublicKeyAtom, creditTokenPublicKey)
    return newStore
  }, [])

  return store
}
